import type { LucideIcon } from "lucide-react";
import {
  Activity,
  BarChart3,
  Battery,
  Bell,
  Briefcase,
  Calendar,
  FileText,
  Flame,
  Gauge,
  History,
  Lock,
  Server,
  Settings,
  Sliders,
  Sparkles,
  TrendingUp,
  Upload,
  Users,
  Wallet,
} from "lucide-react";

import type { Role } from "@/api/auth";

export interface MenuItem {
  /** i18n-ключ для назви пункту. */
  i18nKey: string;
  path: string;
  icon: LucideIcon;
  /** Якщо вказано — пункт видимий лише ролям з цього списку. */
  roles?: Role[];
  /** Опціонально: позначка фази Roadmap, для placeholder-сторінок. */
  phase?: string;
}

export interface MenuSection {
  /** i18n-ключ заголовка секції; null = без заголовка. */
  titleKey: string | null;
  /** Якщо true — секція рендериться як collapsible group (з шевроном). */
  collapsible?: boolean;
  items: MenuItem[];
}

export const MENU_SECTIONS: MenuSection[] = [
  {
    titleKey: null,
    items: [
      { i18nKey: "menu.main_1",         path: "/",                icon: Gauge,        phase: "5" },
      { i18nKey: "menu.main_2",         path: "/home2",           icon: BarChart3,    phase: "5" },
      { i18nKey: "menu.optimizer",      path: "/optimizer",       icon: Sparkles,     phase: "5" },
      { i18nKey: "menu.current_session",path: "/session",         icon: Activity,     phase: "5" },
      { i18nKey: "menu.rdn",            path: "/rdn",             icon: TrendingUp,   phase: "4" },
      { i18nKey: "menu.schedule",       path: "/schedule",        icon: Calendar,     phase: "5" },
      { i18nKey: "menu.finance",        path: "/finance",         icon: Wallet,       phase: "5" },
      { i18nKey: "menu.statistics",     path: "/statistics",      icon: BarChart3,    phase: "5" },
      { i18nKey: "menu.monthly",        path: "/monthly",         icon: BarChart3,    phase: "5" },
      { i18nKey: "menu.kgu_settings",   path: "/kgu-settings",    icon: Sliders,      phase: "2" },
      { i18nKey: "menu.data",           path: "/data",            icon: FileText,     phase: "2" },
    ],
  },
  {
    /** Інше — колапсована група: BESS, лічильники тепла тощо. */
    titleKey: "menu.section_other",
    collapsible: true,
    items: [
      { i18nKey: "menu.bess",           path: "/bess",            icon: Battery,      phase: "5a" },
      { i18nKey: "menu.heat_meters",    path: "/heat-meters",     icon: Flame,        phase: "5" },
    ],
  },
  {
    titleKey: "menu.section_admin",
    /** Адміністрування — колапсована collapsible-група внизу sidebar'а. */
    collapsible: true,
    items: [
      { i18nKey: "menu.admin_tenants",       path: "/admin/tenants",        icon: Briefcase,    roles: ["super_admin"],          phase: "1" },
      { i18nKey: "menu.admin_users",         path: "/admin/users",          icon: Users,        roles: ["super_admin"],          phase: "1a" },
      { i18nKey: "menu.admin_audit",         path: "/admin/audit",          icon: History,      roles: ["admin", "super_admin"], phase: "1" },
      { i18nKey: "menu.admin_sources",       path: "/admin/sources",        icon: Server,       roles: ["super_admin"],          phase: "4" },
      { i18nKey: "menu.settings",            path: "/settings",             icon: Settings,                                      phase: "1a" },
      { i18nKey: "menu.clients",             path: "/clients",              icon: Users,                                         phase: "2" },
      { i18nKey: "menu.notifications",       path: "/notifications",        icon: Bell,                                          phase: "6" },
      { i18nKey: "menu.admin_periods",       path: "/admin/periods",        icon: Lock,         roles: ["super_admin"],          phase: "3" },
      { i18nKey: "menu.admin_import_export", path: "/admin/import-export",  icon: Upload,       roles: ["super_admin"],          phase: "7" },
    ],
  },
];

/** Відфільтрувати секції під роль користувача. */
export function visibleSections(role: Role | undefined): MenuSection[] {
  if (!role) return [];
  return MENU_SECTIONS.map((s) => ({
    ...s,
    items: s.items.filter((it) => !it.roles || it.roles.includes(role)),
  })).filter((s) => s.items.length > 0);
}

